import React, { Fragment, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import LoaderSpinner from "../../common/LoaderSpinner";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';

export default function FundsManager() {
    const [activeTab, setActiveTab] = useState(1);

    const renderHeader = () => {
        const selectedTab = activeTab === 1 ? 'Link/Group Funds' : 'Create Funds';

        return (
            <Fragment>
                <div className="section-body">
                    <div className="container-fluid">
                        <div className="d-flex justify-content-between align-items-center ">
                            <div className="header-action">
                                <h1 className="page-title">Funds Manager</h1>
                                <ol className="breadcrumb page-breadcrumb">
                                    <li className="breadcrumb-item"><span>St. Andrews College</span></li>
                                    <li className="breadcrumb-item active" aria-current="page">{selectedTab}</li>
                                </ol>
                            </div>
                            <Nav tabs className="page-header-tab">
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === 1 })}
                                        onClick={() => setActiveTab(1)}
                                    >
                                        Link/Group Funds
                                    </NavLink>
                                </NavItem>
                                <NavItem style={{ display: "block" }}>
                                    <NavLink
                                        className={classnames({ active: activeTab === 2 })}
                                        onClick={() => setActiveTab(2)}
                                    >
                                        Create Funds
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
    const renderContent = () => {
        return (
            <Fragment>
                <TabPane tabId={1} className={classnames(['fade show'])}>
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Link/Group Funds</h3>
                        </div>

                        <div className="card-body" style={{ marginTop: 0, paddingTop: 0 }}>
                            <p>TODO on this panel:</p>
                            <LoaderSpinner />
                        </div>
                    </div>
                </TabPane>
            </Fragment>
        );
    };

    const renderCreateFundsSection = () => {
        return (
            <Fragment>
                <TabPane tabId={2} className={classnames(['fade show'])}>
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Create or Edit Funds</h3>
                        </div>

                        <div className="card-body" style={{ marginTop: 0, paddingTop: 0 }}>
                            <p>TODO on this panel:</p>
                            <LoaderSpinner />
                        </div>
                    </div>
                </TabPane>
            </Fragment>
        );
    }

    return (
        <Fragment>
            {renderHeader()}
            <div className="section-body mt-4">
                <div className="container-fluid">
                    <TabContent activeTab={activeTab}>
                        {renderContent()}
                        {renderCreateFundsSection()}
                    </TabContent>
                </div>
            </div>
            <ToastContainer />
        </Fragment>
    )
}
